/* eslint-disable import/prefer-default-export, max-len */
import React from 'react';

export const QuestionAlt = (width = '24', height = '24') => (
  <svg style={{ fill: '#0070BA' }} version="1.1" xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 48 48">
    <title>question-alt</title>
    <path d="M23.999 2.666c11.781 0 21.333 9.552 21.333 21.333s-9.552 21.333-21.333 21.333c-11.784 0-21.333-9.552-21.333-21.333s9.549-21.333 21.333-21.333zM21.49 37.332h5.333v-5.333h-5.333v5.333zM30.599 23.935c1.763-1.763 2.733-4.107 2.733-6.603 0-2.493-0.971-4.837-2.733-6.6-3.637-3.635-9.56-3.635-13.197 0l-1.885 1.885 3.768 3.773 1.888-1.885c1.56-1.56 4.096-1.56 5.656 0 0.755 0.755 1.171 1.76 1.171 2.827 0 1.069-0.416 2.075-1.171 2.829-0.755 0.757-1.76 1.171-2.829 1.171h-2.667v8h5.333v-3.051c1.472-0.435 2.819-1.235 3.933-2.347z" />
  </svg>
);
